import { passwordRule, requiredRule } from './validationRules';

export const passwordFields = [
  {
    name: 'password',
    label: 'Новый пароль',
    rules: passwordRule,
    placeholder: 'Введите новый пароль',
  },
  {
    name: 'passwordConfirm',
    label: 'Повторите новый пароль',
    dependencies: ['password'],
    rules: [
      requiredRule,
      passwordRule,
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (!value || getFieldValue('password') === value) {
            return Promise.resolve();
          }

          return Promise.reject(new Error('Пароли должны совпадать!'));
        },
      }),
    ],
    placeholder: 'Подтвердите новый пароль',
  },
];
